import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export function PopUpMenu(props) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <div onClick={e => e.stopPropagation()}>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                size="small"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                {props.button}
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => {
                    setAnchorEl(null);
                }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {props?.editHref ? (
                    <MenuItem
                        component={Link}
                        to={props.editHref}
                        onClick={() => setAnchorEl(null)}>
                        Modifier
                    </MenuItem>
                ) : props?.onEdit ? (
                    <MenuItem onClick={props?.onEdit}>
                        Modifier
                    </MenuItem>
                ) : null}
                <MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        props?.onDelete();
                    }}
                >
                    Supprimer
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        props?.onResendInvitation();
                    }}
                >
                    Renvoyer l'invitation
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        props?.onUpdateStatus();
                    }}
                >
                    {props.labelActive}
                </MenuItem>
            </Menu>
        </div>
    );
}
